import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '@/lib/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useTranslation } from 'react-i18next';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const from = location.state?.from?.pathname || '/admin';

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate(from, { replace: true });
    } catch (err: any) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#111] rounded-3xl p-8 border border-white/5 shadow-2xl">
        <div className="text-center mb-10">
          <h1 className="text-[#F57F25] font-black text-4xl uppercase tracking-tighter mb-2">Bucara</h1>
          <p className="text-white/40 text-sm font-bold tracking-widest uppercase">{t('admin_login_sub')}</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-500 text-xs py-3 px-4 rounded-xl text-center font-bold">
              {error}
            </div>
          )}

          <div>
            <label className="block text-white/50 text-xs font-black uppercase tracking-widest mb-2 ml-1">{t('admin_login_email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-black border border-white/10 rounded-2xl py-4 px-6 text-white focus:outline-none focus:border-[#F57F25] transition-all"
              required
            />
          </div>

          <div>
            <label className="block text-white/50 text-xs font-black uppercase tracking-widest mb-2 ml-1">{t('admin_login_password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-black border border-white/10 rounded-2xl py-4 px-6 text-white focus:outline-none focus:border-[#F57F25] transition-all"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#F57F25] hover:bg-[#e06d15] text-black font-black text-sm uppercase py-4 rounded-2xl transition-all shadow-lg shadow-[#F57F25]/20 flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-black"></div>
            ) : (
              <>
                <i className="ri-login-box-line text-lg"></i>
                {t('admin_login_signin')}
              </>
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
          <button 
            onClick={() => navigate('/')}
            className="text-white/30 hover:text-[#F57F25] text-xs font-bold transition-colors uppercase tracking-widest"
          >
            {t('admin_login_back')}
          </button>
        </div>
      </div>
    </div>
  );
}
